
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.78723 12.9139L12.7518 10.1951L12.766 10.3375C12.766 11.766 11.5001 12.9268 9.94252 12.9268L9.78723 12.9139Z"}}),_c('path',{attrs:{"d":"M10.0029 14.679C12.5101 14.679 14.5449 12.7523 14.5449 10.3783C14.5449 9.82352 14.4269 9.29454 14.2225 8.80858L16.8796 6.2927C18.2513 7.37647 19.3323 8.77846 20 10.3783C18.4239 14.1543 14.5495 16.8293 10.0029 16.8293C8.73114 16.8293 7.5139 16.6143 6.38293 16.2272L8.3451 14.3736C8.85829 14.5629 9.41696 14.679 10.0029 14.679Z"}}),_c('path',{attrs:{"d":"M0.8936 16.9263L2.93104 15.0063L3.33765 14.6231C1.86319 13.5368 0.697018 12.0926 -6.72926e-07 10.421C1.54597 6.72421 5.36168 4.10525 9.82977 4.10525C11.2149 4.10525 12.5374 4.35788 13.7483 4.81684L14.1281 4.45894L16.733 2L17.8723 3.06946L2.03296 18L0.8936 16.9263ZM5.83531 12.2737L7.21595 10.9726C7.17573 10.7915 7.14893 10.6105 7.14893 10.421C7.14893 9.02735 8.35082 7.89473 9.82977 7.89473C10.0308 7.89473 10.223 7.91999 10.4106 7.95789L11.7913 6.65683C11.197 6.37894 10.5358 6.2105 9.82977 6.2105C7.36339 6.2105 5.36168 8.09683 5.36168 10.421C5.36168 11.0863 5.54042 11.7095 5.83531 12.2737Z"}})])
          )
        }
      }
    